import { styled } from "@mui/material/styles";

import { mentionTagStyles } from "./MentionTag";

export const TextEditorRoot = styled("div", {
  shouldForwardProp: (prop) => prop !== "disabled",
})<{ disabled?: boolean }>(({ theme, disabled }) => ({
  opacity: disabled ? 0.5 : 1,
  // Grid stacks children in same cell so placeholder affects container height
  display: "grid",
  width: "100%",

  "& > *": {
    gridArea: "1 / 1",
    minWidth: 0, // make sure the text does not overflow for long text without spaces
  },

  "& p": {
    margin: 0,
    ...theme.typography.regular,
  },

  ".placeholder": {
    zIndex: 1,
    pointerEvents: "none", // we need the pointerEvents to capture the click through to the editor
    padding: theme.spacing(2),
    fontSize: 14,
    color: theme.palette.secondary[3],

    "& a, & button": {
      pointerEvents: "auto", // related to the pointerEvents: "none" on the placeholder. hacky but will encourage good a11y at least.
    },
  },

  ".tiptap": {
    outline: "none",
    fontSize: 14,
    padding: theme.spacing(2),

    "[data-type='mention']": {
      ...mentionTagStyles(theme),

      "&::after": {
        content: "'\\200B'",
      },
    },

    "&:has([data-type='mention']) p": {
      lineHeight: 1.7,
    },

    "& affix": {
      fontSize: 14,

      "&:not(.modified)": {
        color: theme.palette.success.main,
      },
    },
  },
}));
